import { ArrowRightIcon, QuestionMarkCircleIcon } from '@heroicons/react/outline';

const AndroidHome = ({ alreadyHaveAccount = () => { } }) => {
	return (
		<div className="p-4">
			<h4 className="text-gray-900 mb-2 text-xl font-bold">
				Google Developer Account
			</h4>
			<p className="text-gray-600 mb-4 text-base">
				To publish Android apps on Google Play, you'll need to create a Google
				Play Developer account. Google Play requires a one time $25 registration
				fee charged for a Google Play Developer Console account. After submission,
				expect a review wait time of 5-7 days for your app to be reviewed and approved by Google.
			</p>
			<div className="flex flex-col gap-2">
				<div className="flex items-center gap-2 mb-2">
					<a
						href='https://docs.appmaker.xyz/docs/publishing/androidpublishing'
						target="_blank"
						rel="noopener noreferrer"
						className="group relative inline-flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white shadow-md hover:shadow-lg transform hover:scale-110 transition-all duration-200 ease-in-out"
						title="View Publishing Guide"
					>
						<QuestionMarkCircleIcon className="h-5 w-5 animate-pulse" />
						<span className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-ping"></span>
						<span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full"></span>
					</a>
					<span className="text-sm text-gray-600 font-medium">Need help? Click for publishing guide</span>
				</div>
				<span className="relative z-0 inline-flex gap-4 rounded-md">
					<a
						href='https://docs.appmaker.xyz/docs/publishing/google-dev-account-setup'
						className="relative inline-flex items-center px-4 py-2 rounded-md bg-blue-500 text-base font-medium text-white hover:bg-blue-600 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
						target="_blank"
						rel="noopener noreferrer"
					>
						Get a Google Developer Account
					</a>
					<button
						type="button"
						className="relative group inline-flex gap-1 items-center px-4 py-2 rounded-r-md text-base font-medium text-blue-500 hover:text-blue-700 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
						onClick={() => {
							alreadyHaveAccount();
						}}
					>
						I already have an account{' '}
						<ArrowRightIcon className="h-3 w-3 group-hover:translate-x-1 transform transition-all" />
					</button>
				</span>
			</div>
		</div>
	);
};

export default AndroidHome;
